export default {
  getMessage: field => `${field} is not a time`,
  validate(value) {
    return new Promise((resolve) => {
      const split = value.split(':');
      const hours = split[0];
      const minutes = split[1];
      resolve({
        valid:
          (split.length === 2
            && !Number.isNaN(hours)
            && !Number.isNaN(minutes)
            && minutes < 60
            && minutes >= 0
            && hours >= 0
            && hours < 24)
          || parseInt(value, 10) === 0,
      });
    });
  },
};
